// Story Slider
// ------------------------------------------
function storySlider() {

    var module = $('.pagebuilder section.quotes');
    var slider = module.find('.slider');
    var prev = module.find('.prev');
    var next = module.find('.next');

    slider.slick({
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        centerMode: true,
        // accessibility: false,
        // focusOnChange: false,
        prevArrow: '<button class="prev" title="Previous Slide"><i class="icon"><svg viewBox="0 0 20 32" id="chevron" xmlns="http://www.w3.org/2000/svg" width="20" height="32"><g class="nc-icon-wrapper" fill="#ffffff"><path d="M3.053.707L.706 3.054a1 1 0 0 0 0 1.413L12.213 16 .706 27.533a1 1 0 0 0 0 1.413l2.347 2.347a1 1 0 0 0 1.414 0L19.76 16 4.467.707a1 1 0 0 0-1.414 0z"></path></g></svg></i></button>',
        nextArrow: '<button class="next" title="Next Slide"><i class="icon"><svg viewBox="0 0 20 32" id="chevron" xmlns="http://www.w3.org/2000/svg" width="20" height="32"><g class="nc-icon-wrapper" fill="#ffffff"><path d="M3.053.707L.706 3.054a1 1 0 0 0 0 1.413L12.213 16 .706 27.533a1 1 0 0 0 0 1.413l2.347 2.347a1 1 0 0 0 1.414 0L19.76 16 4.467.707a1 1 0 0 0-1.414 0z"></path></g></svg></i></button>',
        responsive: [
            {
                breakpoint: 1680,
                settings: {
                    slidesToShow: 1.5
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1.1
                }
            },
            {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    centerMode: false
                }
            }
        ]
    });

    // setTimeout(() => {
    //   Foundation.reInit($('[data-equalizer]'));
    // }, 3000);

    prev.click(function () {
        var module = $(this).parent().parent();
        var slider = module.find('.slider');
        slider.slick('slickPrev');
        console.log('Prev start');
        Foundation.reInit($('[data-equalizer]'));
        console.log('Prev finish');
    });

    next.click(function () {
        var module = $(this).parent().parent();
        var slider = module.find('.slider');
        slider.slick('slickNext');
        console.log('Next start');
        Foundation.reInit($('[data-equalizer]'));
        console.log('Next finish');
    });

    // Jobs to do for each slider...
    slider.each(function (i) {

        slides = $(this).find('.slide');

        // If single slide, destroy the slider
        if (slides.length == 1) $(this).slick('unslick');

    });

}

$( document ).ready(function() {
    storySlider();
});

// $('.reinit-btn').on('click', function() { Foundation.reInit($('[data-equalizer]')); });
